import cookieFr from './cookiePolicy/fr';
import cookieEs from './cookiePolicy/es';
import cookieAr from './cookiePolicy/ar';

const cookieEn = {
  title: 'Cookie Policy',
  lastUpdated: 'Last updated: 26 May 2026',
  back: '← Back to home',
  intro: [
    {
      type: 'p',
      text: 'This Cookie Policy explains how Demakstore Gıda İhracat San. ve Tic. Ltd. Şti., operating under the brand name DeMaxtore (“DeMaxtore”, “we”, “us”, or “our”), uses cookies and similar technologies on www.demaxtore.com.',
    },
    {
      type: 'p',
      text: 'By using our website, you may choose to accept, reject, or manage certain cookies depending on their purpose. Some cookies are necessary for the proper functioning of the website, while others are used to improve user experience, analyze website performance, and support marketing activities.',
    },
  ],
  sections: [
    {
      title: '1. Manage Your Cookie Preferences',
      blocks: [
        {
          type: 'p',
          text: 'Some functions on our website may be based on services provided by third parties. If you give your consent, these third parties may place cookies or similar technologies on your device to allow you to view, interact with, or share content hosted by those third parties.',
        },
        {
          type: 'p',
          text: 'These cookies may allow third parties to collect and use your browsing data for their own purposes, in accordance with their own privacy and cookie policies.',
        },
        {
          type: 'p',
          text: 'You may give or withdraw your consent at any time, either globally or by cookie category, where such options are available.',
        },
        {
          type: 'p',
          text: 'By default, non-essential cookies are not placed unless you provide your consent, where required by applicable law.',
        },
      ],
    },
    {
      title: '2. About Cookies',
      blocks: [
        {
          type: 'p',
          text: 'We use different types of cookies on our website to ensure the website works properly, measure audience activity, improve performance, and enhance the interactivity of our services.',
        },
        {
          type: 'p',
          text: 'Cookies may help us understand how visitors use our website, which pages are visited, how users interact with our services, and how we can improve the website experience.',
        },
      ],
    },
    {
      title: '3. What Is a Cookie?',
      blocks: [
        {
          type: 'p',
          text: 'A cookie is a small text file or piece of information that may be stored on your device when you visit a website.',
        },
        {
          type: 'p',
          text: 'Cookies allow a website to recognize your browser or device during your visit or when you return to the website later. They may be used for several purposes, such as:',
        },
        {
          type: 'ul',
          items: [
            'Keeping the website secure',
            'Remembering user preferences',
            'Maintaining session information',
            'Measuring website traffic',
            'Improving website functionality',
            'Supporting analytics and marketing activities',
            'Enabling third-party content or integrations',
          ],
        },
        {
          type: 'p',
          text: 'Cookies may be temporary cookies that are deleted when you close your browser, or persistent cookies that remain on your device for a defined period.',
        },
      ],
    },
    {
      title: '4. Types of Cookies We Use',
      blocks: [
        {
          type: 'p',
          text: 'DeMaxtore may use the following types of cookies:',
        },
      ],
    },
    {
      title: '4.1 Strictly Necessary Cookies',
      blocks: [
        {
          type: 'p',
          text: 'These cookies are required for the website to function properly. They allow core features of the website to work, such as:',
        },
        {
          type: 'ul',
          items: [
            'Page navigation',
            'Security',
            'User session management',
            'Form submission',
            'Cookie preference management',
            'Access to secure areas of the website',
          ],
        },
        {
          type: 'p',
          text: 'You can technically block these cookies through your browser settings, but doing so may cause parts of the website to stop working properly or reduce your browsing experience.',
        },
        {
          type: 'p',
          text: 'These cookies do not require consent where they are strictly necessary for the operation of the website.',
        },
      ],
    },
    {
      title: '4.2 Performance and Analytics Cookies',
      blocks: [
        {
          type: 'p',
          text: 'These cookies help us understand how visitors use our website. They allow us to measure and analyze:',
        },
        {
          type: 'ul',
          items: [
            'Website traffic',
            'Page views',
            'Visitor behavior',
            'Time spent on pages',
            'Technical performance',
            'User interaction with website features',
          ],
        },
        {
          type: 'p',
          text: 'This information helps us improve the structure, content, speed, and usability of www.demaxtore.com.',
        },
        {
          type: 'p',
          text: 'Analytics cookies are only used where permitted by law and, where required, based on your consent.',
        },
      ],
    },
    {
      title: '4.3 Functional Cookies',
      blocks: [
        {
          type: 'p',
          text: 'Functional cookies allow the website to remember choices you make and provide enhanced features.',
        },
        {
          type: 'p',
          text: 'These may include:',
        },
        {
          type: 'ul',
          items: [
            'Language preferences',
            'Region preferences',
            'Previously entered form information',
            'Interface preferences',
            'User experience improvements',
          ],
        },
        {
          type: 'p',
          text: 'If these cookies are disabled, some personalized features may not function properly.',
        },
      ],
    },
    {
      title: '4.4 Marketing and Advertising Cookies',
      blocks: [
        {
          type: 'p',
          text: 'Marketing cookies may be used to deliver more relevant content, measure campaign performance, and understand the effectiveness of our advertising activities.',
        },
        {
          type: 'p',
          text: 'These cookies may collect information about your browsing behavior on our website and, in some cases, across other websites.',
        },
        {
          type: 'p',
          text: 'They may be placed by DeMaxtore or by third-party advertising and analytics providers, depending on the tools used on the website.',
        },
        {
          type: 'p',
          text: 'Marketing cookies are only used with your consent where required by applicable law.',
        },
      ],
    },
    {
      title: '4.5 Third-Party Cookies',
      blocks: [
        {
          type: 'p',
          text: 'Our website may rely on services provided by third parties to improve functionality, interactivity, analytics, communication, or marketing performance.',
        },
        {
          type: 'p',
          text: 'These third-party services may include tools such as:',
        },
        {
          type: 'ul',
          items: [
            'Website analytics providers',
            'Advertising platforms',
            'Embedded video or media services',
            'Chat or communication tools',
            'Social media integrations',
            'CRM, form, or tracking tools',
            'Security and performance tools',
          ],
        },
        {
          type: 'p',
          text: 'These third parties may place cookies directly on your device when you interact with their services on our website.',
        },
        {
          type: 'p',
          text: 'Through these cookies, third parties may collect and use your browsing data for their own purposes, including analytics, targeted advertising, content personalization, or service improvement.',
        },
        {
          type: 'p',
          text: 'For more information, please review the privacy and cookie policies of the relevant third-party providers.',
        },
      ],
    },
    {
      title: '5. Cookies Used for Website Functionality',
      blocks: [
        {
          type: 'p',
          text: 'Some cookies are necessary to provide key website functions and services. These cookies help ensure that:',
        },
        {
          type: 'ul',
          items: [
            'The website loads correctly',
            'Contact forms work properly',
            'Security features operate effectively',
            'User sessions are maintained',
            'Cookie choices are remembered',
            'Website features remain stable',
          ],
        },
        {
          type: 'p',
          text: 'Without these cookies, some parts of the website may not work as intended.',
        },
      ],
    },
    {
      title: '6. Cookies Used to Improve Interactivity',
      blocks: [
        {
          type: 'p',
          text: 'DeMaxtore may use third-party tools to improve the interactivity of the website. These tools may support features such as:',
        },
        {
          type: 'ul',
          items: [
            'Embedded videos',
            'Interactive forms',
            'Live chat or messaging',
            'Social sharing',
            'External content visualization',
            'Analytics dashboards',
            'Marketing campaign tracking',
          ],
        },
        {
          type: 'p',
          text: 'These features may use third-party cookies placed directly by the service providers.',
        },
        {
          type: 'p',
          text: 'If you do not consent to these cookies, some interactive content or third-party features may not be available.',
        },
      ],
    },
    {
      title: '7. Cookie Consent',
      blocks: [
        {
          type: 'p',
          text: 'Where required by applicable law, we ask for your consent before placing non-essential cookies on your device.',
        },
        {
          type: 'p',
          text: 'You may:',
        },
        {
          type: 'ul',
          items: [
            'Accept all cookies',
            'Reject non-essential cookies',
            'Manage your preferences by category',
            'Withdraw your consent at any time',
          ],
        },
        {
          type: 'p',
          text: 'If you withdraw your consent, cookies that were previously placed may remain on your device until you delete them through your browser settings or until they expire.',
        },
      ],
    },
    {
      title: '8. How to Manage Cookies',
      blocks: [
        {
          type: 'p',
          text: 'You can manage cookies in two ways:',
        },
        {
          type: 'p',
          text: 'Through our cookie preference tool',
        },
        {
          type: 'p',
          text: 'Where available, you can manage your cookie preferences directly through the cookie banner or cookie settings panel on our website.',
        },
        {
          type: 'p',
          text: 'Through your browser settings',
        },
        {
          type: 'p',
          text: 'Most browsers allow you to:',
        },
        {
          type: 'ul',
          items: [
            'View cookies stored on your device',
            'Delete cookies',
            'Block cookies',
            'Set preferences for certain websites',
            'Receive warnings before cookies are stored',
          ],
        },
        {
          type: 'p',
          text: 'Please note that blocking all cookies may affect the functionality and performance of our website.',
        },
      ],
    },
    {
      title: '9. Third-Party Responsibility',
      blocks: [
        {
          type: 'p',
          text: 'Third-party cookies are controlled by the relevant third-party providers. DeMaxtore does not fully control how third parties use cookies or process data collected through their own technologies.',
        },
        {
          type: 'p',
          text: 'We recommend reviewing the privacy and cookie policies of third-party services you interact with through our website.',
        },
      ],
    },
    {
      title: '10. Changes to This Cookie Policy',
      blocks: [
        {
          type: 'p',
          text: 'We may update this Cookie Policy from time to time to reflect changes in our website, cookie usage, third-party tools, legal requirements, or business operations.',
        },
        {
          type: 'p',
          text: 'Any updates will be published on this page with the revised “Last Updated” date.',
        },
      ],
    },
    {
      title: '11. Contact',
      blocks: [
        {
          type: 'p',
          text: 'For questions about this Cookie Policy or our use of cookies, please contact us:',
        },
        {
          type: 'ul',
          items: [
            'Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.',
            'Operating Brand: DeMaxtore',
            'Website: www.demaxtore.com',
            'Email: support@demaxtore.com',
            'Alternative Email: demaxtore@demaxtore.com',
          ],
        },
      ],
    },
  ],
};

export const COOKIE_POLICY_BY_LANG = {
  en: cookieEn,
  fr: cookieFr,
  es: cookieEs,
  ar: cookieAr,
};
